import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useRouter } from 'next/router';
import { apiClientV2 } from '~/api/client';
import { Creator } from '~/clientApi/creator.model';

import { CountriesEntity, LabelValuePair } from './useGetIGInsights';

export const useGetYTInsights = ({ id }: { id?: string }) => {
  const router = useRouter();

  return useQuery({
    queryKey: ['insights-youtube', { id }],
    queryFn: () => {
      if (router.asPath.includes('/media-kits/')) {
        // GET data using SSR Token for media kits
        return axios
          .get<YTInsights>(`/api/insights/${id}/yt`)
          .then((r) => r.data);
      }

      return apiClientV2
        .get<YTInsights>(`/yt-channels/${id}`)
        .then((r) => r.data);
    },
    enabled: Boolean(id),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};

export interface YTInsights {
  id: string;
  active: boolean;
  thumbnails?: null[] | null;
  creator: Partial<Creator>;
  countries?: CountriesEntity[];
  locales?: null[] | null;
  genders?: LabelValuePair[];
  gendersPerAge?: null[] | null;
  ages: LabelValuePair[];
  ytHandle: string;
  createdAt: string;
  updatedAt: string;
  createdAtAgo: string;
  updatedAtAgo: string;
  demographicsLastUpdatedAt: string;
}
